import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export const fetchRegions = () => performRequest({
    method: ERequestType.GET,
    url: 'fileupload/regionList',
});
